import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import {
  CheckCircle2, CalendarCheck, MessageCircle, Clock,
  ArrowLeft, Send,
} from 'lucide-react';

const ConfirmationStep = ({ isSubmitting, onBack, onConfirm }) => {
  return (
    <div>
      <h4 className="h5 fw-semibold text-center mb-4" style={{ color: '#333' }}>
        Confirmar cita
      </h4>

      <Card style={{ border: '1px solid #FCE4EC', borderRadius: 12 }}>
        <Card.Body className="p-4">
          {/* Icon */}
          <div className="text-center mb-3">
            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center"
              style={{ width: 64, height: 64, backgroundColor: '#FFF0F5' }}
            >
              <CalendarCheck size={32} style={{ color: '#EF60A3' }} />
            </div>
          </div>

          <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
            Al confirmar su cita, nuestro equipo recibira su solicitud y se pondra en contacto con usted.
          </p>

          {/* Info items */}
          <div className="mb-4">
            <div
              className="d-flex align-items-start gap-3 p-3 mb-2"
              style={{ backgroundColor: '#FFF8FA', borderRadius: 10, border: '1px solid #FCE4EC' }}
            >
              <MessageCircle size={18} className="flex-shrink-0 mt-1" style={{ color: '#EF60A3' }} />
              <div>
                <p className="fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333' }}>
                  Sera contactado por un representante
                </p>
                <p className="mb-0 text-muted" style={{ fontSize: '0.78rem' }}>
                  Un representante se comunicara con usted via WhatsApp o llamada para confirmar los detalles de su cita.
                </p>
              </div>
            </div>

            <div
              className="d-flex align-items-start gap-3 p-3"
              style={{ backgroundColor: '#FFF8FA', borderRadius: 10, border: '1px solid #FCE4EC' }}
            >
              <Clock size={18} className="flex-shrink-0 mt-1" style={{ color: '#EF60A3' }} />
              <div>
                <p className="fw-semibold mb-1" style={{ fontSize: '0.82rem', color: '#333' }}>
                  Tiempo de respuesta
                </p>
                <p className="mb-0 text-muted" style={{ fontSize: '0.78rem' }}>
                  Normalmente respondemos en un plazo de 1 a 2 horas durante horario laboral (Lun-Sab, 9AM-6PM).
                </p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Navigation */}
      <div className="d-flex justify-content-between mt-4">
        <Button variant="outline-secondary" onClick={onBack} disabled={isSubmitting}>
          <ArrowLeft size={14} className="me-1" /> Atras
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isSubmitting}
          style={{
            backgroundColor: '#EF60A3',
            borderColor: '#EF60A3',
            borderRadius: 20,
            padding: '8px 24px',
          }}
        >
          {isSubmitting ? (
            <span className="d-inline-flex align-items-center gap-2">
              <Spinner animation="border" size="sm" />
              Enviando...
            </span>
          ) : (
            <span className="d-inline-flex align-items-center gap-2">
              <Send size={14} />
              Confirmar Cita
            </span>
          )}
        </Button>
      </div>
    </div>
  );
};

/** Post-confirmation success screen */
export const SuccessStep = ({ isAuthenticated = true }) => {
  return (
    <div className="d-flex justify-content-center py-4">
      <Card className="w-100 text-center" style={{ maxWidth: 480, border: '1px solid #FCE4EC', borderRadius: 16 }}>
        <Card.Body className="py-5 px-4">
          <div className="d-flex justify-content-center mb-3">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 80, height: 80, backgroundColor: '#E8F5E9' }}
            >
              <CheckCircle2 size={48} color="#388E3C" />
            </div>
          </div>

          <h2 className="h4 fw-bold mb-2" style={{ color: '#333' }}>
            Su cita ha sido enviada
          </h2>
          <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
            {isAuthenticated
              ? 'Hemos recibido su solicitud exitosamente. Un representante se comunicara con usted pronto.'
              : 'Hemos recibido su solicitud. Un representante se comunicara con usted para confirmar los detalles.'}
          </p>

          {isAuthenticated ? (
            <Button
              as={Link}
              to="/mis-citas"
              className="w-100 d-inline-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: '#EF60A3',
                borderColor: '#EF60A3',
                borderRadius: 20,
                padding: '10px 20px',
              }}
            >
              <CalendarCheck size={16} />
              Ver mis citas
            </Button>
          ) : (
            <>
              <Button
                as={Link}
                to="/"
                className="w-100 d-inline-flex align-items-center justify-content-center gap-2 mb-3"
                style={{
                  backgroundColor: '#EF60A3',
                  borderColor: '#EF60A3',
                  borderRadius: 20,
                  padding: '10px 20px',
                }}
              >
                Volver al inicio
              </Button>
              <div
                className="p-3 rounded-3"
                style={{ backgroundColor: '#FFF0F5', border: '1px solid #FCE4EC' }}
              >
                <p className="small mb-2 fw-semibold" style={{ color: '#333' }}>
                  Cree su cuenta para gestionar sus citas
                </p>
                <Button
                  as={Link}
                  to="/registro"
                  variant="outline-primary"
                  size="sm"
                  className="rounded-pill px-3"
                >
                  Crear cuenta
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConfirmationStep;
